export function injectElement({
  content,
  target,
  tag,
  selector,
}: {
  target: HTMLElement;
  tag: string;
  content: string;
  selector: string;
}): void {
  const element: HTMLElement = document.createElement(tag);
  element.classList.add(selector);
  element.innerHTML = content;
  target.appendChild(element);
}
